<button
  #button
  type="{{ type }}"
  class="btn {{ purpose }}"
  [class.btn-secondary-light]="enableLight"
  [disabled]="disabled"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-haspopup]="ariaHaspopup"
>
  {{ buttonText }}
  <ng-content></ng-content>
</button>
